<div mat-dialog-title class="flex">
  <h3>Challenge Property</h3>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content>
  <!-- Warning Message -->
  <p class="warning-message">
    In the EULA you agreed to there is a $500.00 fine representing a property that you do not own or manage.
  </p>

  <!-- Property Info -->
  <div class="property-info pt-1 pb-3">
    <div>Address: {{property.address}}</div>
    <div>City: {{property.city}}</div>
    <div>Zip Code: {{property.zipCode}}</div>
  </div>

  <!-- Form -->
  <form [formGroup]="form" (submit)="form.valid && onSubmit(f)" #f="ngForm" novalidate>
    <!-- Comments -->
    <div class="input-group">
      <textarea class="form-control comments" rows="4" placeholder="Enter notes..." formControlName="notes"
        [ngClass]="{ 'is-invalid': f.submitted && notes.invalid }" required>
      </textarea>

      <!-- Invalid Email -->
      <div *ngIf="f.submitted && notes.invalid" class="invalid-feedback">
          <div class="mb-1" *ngIf="notes.errors!.required">Notes are required</div>
      </div>
    </div>

    <!-- Buttons -->
    <mat-dialog-actions>
        <button mat-button type="button" class="mat-raised-button" (click)="close()">Close</button>
        <button mat-button type="submit" class="mat-raised-button ml-1" color="primary">Submit</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
